﻿import { appSiteUrl } from '../../config';
import axiosInstance from '../../utils/axios';
import { NotificationApiClient, BreedMateNotification } from '../../api/Notification';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';

const useQueryOptions = {
  refetchOnWindowFocus: false,
};

const notificationApiClient = new NotificationApiClient(appSiteUrl, axiosInstance);

const notificationsQuery = 'notifications';

export const useGetNotifications = (executeOnInitialRender = true) =>
  useQuery<BreedMateNotification[], Error>({
    queryKey: [notificationsQuery],
    queryFn: async () => notificationApiClient.getAll_Get(),
    ...useQueryOptions,
    enabled: executeOnInitialRender,
  });

export const useUpdateNotification = () => {
  const queryClient = useQueryClient();

  return useMutation<
    BreedMateNotification,
    Error,
    { id: number; notification: BreedMateNotification }
  >({
    mutationFn: async ({ id, notification }) => notificationApiClient.update_Patch(id, notification),
    onSuccess: () => {
      // Invalidate and refetch notifications queries
      queryClient.invalidateQueries({ queryKey: [notificationsQuery] });
    },
  });
};
